<template>
  <div class="pages">

    <div class="load_text">跳转中…</div>
    <div class="load_text_1">人多时会有些慢，请耐心等待~</div>

    <!-- <div @click="repeatClick" class="repat-btn">再试一次</div> -->
    <!-- <div class="saveToXcxs" v-if="loading">
      <p class="xcxP2">
        <img src="../../assets/img/loads.svg" alt class="loads" />
        同步中
      </p>
    </div> -->

    <transition name="el-zoom-in-top">
    <div class="generalTip" :class="tipType ? 'black' : ''" v-show="tipShow">
      <p>{{ tipMessage }}</p>
    </div>
  </transition>
  </div>
</template>

<script>
// import headers from "../../components/header";
//import lrz from "lrz";
import { Message } from "element-ui";
import { getMiniUrlLink } from "@/request/api";
import storage from '../../utils/storage';

import Axios from "axios";

let that

export default {
//   components: { headers },
  name: "urllink",
  data() {
    return {
      type: "0",
      path: "",
      data: "",
      linkUrl:"",
      loading: true,
      loadText: '授权中，请稍候...',
      errorMask: false,
      tipShow: false,
      tipType: false,
      tipMessage: "通用错误，Message:错误信息",
    };
  },
  mounted() {
    that = this
    console.log('route', this.$route);

    that.type = this.$route.query.type;
    that.path = this.$route.query.path;
    that.data = this.$route.query.data;

    if(!that.type || !that.path)
    {
      Message.error("非法请求！");
      return
    }

    that.path = decodeURIComponent(that.path)
    if(!that.data)
    {
      that.data = decodeURIComponent(that.data)
    }

    // that.path = 'subPage/newGuide/index'
    // that.data = 'trial=1'

    that.initData()
  },
  methods: {
    repeatClick()
    {
      if(that.linkUrl){
        window.location.href = that.linkUrl;
        return;
      }

      that.initData()
    },
    initData()
    {
      var key = that.getKey();
      var localData = storage.get(key)
      
      if(localData && localData.item)
      {
        try{
          var url = decodeURIComponent(localData.item)
          if(url)
          {
            console.log('localData',url)
            that.linkUrl = url;

            //Message.success('授权成功')
            window.location.href = that.linkUrl;
            return;
          }
        }
        catch{

        }
        
      }
      that.getUrlLink()
    },
    // 获取项目列表
    getUrlLink() {
      var params = {
        path:that.path,
      }

      if(that.data)
      {
        params.data = that.data
      }

      getMiniUrlLink(params).then((res) => {

        console.log('getMiniUrlLink',res)
        if (res.data && res.data.data
           && res.data.data.data && res.data.data.data.url_link)
        {
          that.loading = true;
          that.loadText = '授权成功';
          
          var url_link = res.data.data.data.url_link;
          var key = that.getKey();

          storage.set(key,encodeURIComponent(url_link))

          that.linkUrl = url_link;

          //Message.success('授权成功')
          window.location.href = that.linkUrl;
        } 
        else 
        {
          that.tipShow = true;
          that.tipType = false;
          that.tipMessage = "授权失败";
          setTimeout(() => {
            that.tipShow = false;
          }, 1000);
          that.loading = false;
          that.loadText = '授权失败';
          // that.transparentMask = false;
        }
      });
    },
    getKey()
    {
      var key = this.type + '_' +  this.path 
      if(that.data)
      {
        key = key + '_' + that.data
      }

      return key;
    }
  }
};
</script>

<style lang="less" scoped>

.load_text{
  // margin-top: calc(50vh - 0.6rem);
  margin-top: calc(30vh);
  margin-left: calc(50vw - 3rem);
  width: 6rem;
  color: #000;
  font-size: 0.8rem;
  font-weight: bold;
}

.load_text_1{
  margin-top: 0.2rem;
  margin-left: calc(50vw - 3rem);
  width: 6rem;
  color: #888;
  font-size: 0.4rem;
}

.repat-btn{
  position: fixed;
  left: calc(50vw - 3rem);
  bottom: calc(20vh);
  width: 6rem;
  height: 1rem;
  line-height: 1rem;
  border-radius: 0.5rem;
  text-align: center;
  background: #000;
  color: #fff;
  font-size: 0.5rem;
  line-height: 88rpx;
  z-index: 100;
}

.generalTip {
  position: fixed;
  top: 12px;
  left: 50%;
  background: #ec4d3d;
  color: #ffffff;
  padding: 10px;
  text-align: center;
  border-radius: 20px;
  width: 280px;
  margin-left: -160px;
  z-index: 1009;
}

.black {
  background: #000;
}

 .saveToXcxs {
      width: 150px;
      height: 40px;
      background: #000;
      border-radius: 40px;
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column-reverse;
      z-index: 999;
      margin-left: 20px;
      cursor: pointer;
      .xcxP2 {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

</style>
